import { render, staticRenderFns } from "./Vinos.vue?vue&type=template&id=3e737b6f&"
import script from "./Vinos.vue?vue&type=script&lang=js&"
export * from "./Vinos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports